// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"o0CcIVMbqOxdrb8sHO8k0g==","link":"yx2mLHAJXABRuQmQBPjDTg=="};